import React, { useState } from 'react'
import { Typography } from "@mui/material"
import { blueGrey } from "@mui/material/colors";
import { useEffect } from 'react';
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil';
import { listViewerExamsFetchState, viewerExamsState } from 'src/Patient/state/atoms';
import EmptyCalendar from 'src/shared/components/notFoundData/EmptyCalendar';
import HoursAvailableSkeleton from 'src/shared/components/skeletons/HoursAvailableSkeleton';
import useCatchErrorApi from 'src/shared/hooks/useCatchErrorApi';
import { userState } from 'src/store/user/userState';
import { activeTabReservationsPatientState } from '../state/atoms';
import CardExam from './CardExam'

const ListViewerExams = () => {
    const { catchErrorApi } = useCatchErrorApi();
    const user = useRecoilValue(userState);
    const [viewerExams, setviewerExams] = useRecoilState(viewerExamsState);
        console.log(viewerExams);
        
    const [loading, setLoading] = useState(false)
    const activeTabReservationsPatient = useRecoilValue(activeTabReservationsPatientState);

    const viewerExamsCallback = useRecoilCallback(({ snapshot }) => async () => {
        setLoading(true)
        try {
            if (activeTabReservationsPatient === "3") {
                setviewerExams([])
                const examsFetch = await snapshot.getPromise(listViewerExamsFetchState(user.payload.uswRut));                
                let examenes = examsFetch.slice();
                console.log("examenes", examenes);
                
                examenes.sort((x,y) => { return y.fechaExamenTipoDate - x.fechaExamenTipoDate })
                // examenes.sort((x,y) => { return parseInt(y.codigo) - parseInt(x.codigo) })
                // console.log("ascending", examenes);

                // setviewerExams(examsFetch)
                setviewerExams(examenes)
            }

        } catch (error) {
            setviewerExams([]);
        } finally {
            setLoading(false)
        }
    }, [activeTabReservationsPatient]);

    useEffect(() => {
        viewerExamsCallback()
    }, [viewerExamsCallback])

    if (loading) return <HoursAvailableSkeleton />
    if (!loading && viewerExams && viewerExams.length === 0) return <EmptyCalendar text={"No tienes exámenes registrados"} />

    return (
        <div>
            <Typography textAlign={"start"} variant="h4" paddingY={1} color={blueGrey[600]}>
                RESULTADOS EXÁMENES
            </Typography>
            {
                viewerExams.map((el, index) => (
                    <CardExam cancelReservation={false} key={`${el.id}_${index}`} professional={el} />
                ))
            }
        </div>
    )
}

export default ListViewerExams
